<script setup>
import { computed } from 'vue'
import { useProfileStore } from '@/stores/profile'
import { useTranslaterStore } from '@/stores/translater'
import { useRequestsStore } from '@/stores/requests'
import checkArrayIncludes from '@/helpers/checkArrayIncludes.js'

import iconCarsActive from '@/assets/images/icons/icon-cars-active.svg'
import iconCars from '@/assets/images/icons/icon-cars.svg'
import iconAreasActive from '@/assets/images/icons/icon-areas-active.svg'
import iconAreas from '@/assets/images/icons/icon-areas.svg'
import iconFirmwareActive from '@/assets/images/icons/icon-firmware-active.svg'
import iconFirmware from '@/assets/images/icons/icon-firmware.svg'
import iconUsersActive from '@/assets/images/icons/icon-users-active.svg'
import iconUsers from '@/assets/images/icons/icon-users.svg'
import iconGuideActive from '@/assets/images/icons/icon-guide-active.svg'
import iconGuide from '@/assets/images/icons/icon-guide.svg'

const profileStore = useProfileStore()
const translaterStore = useTranslaterStore()
const requestsStore = useRequestsStore()

const profile = computed(() => profileStore.profile)
const getTranslate = computed(() => translaterStore.getTranslate)
</script>

<template>
    <nav class="asw-navi" role="navigation">
        <ul class="asw-navi-list flex-column flex-xl-row">
            <li class="asw-navi-list__item">
                <router-link
                    to="/cars"
                    class="asw-navi-list__link"
                    :class="{ 'asw-navi-list__link--active': $route.path == '/cars' }"
                >
                    <img
                        :src="$route.path == '/cars' ? iconCarsActive : iconCars"
                        class="asw-navi-list__link-img"
                        alt=""
                    />
                    <span class="asw-navi-list__link-text">{{ getTranslate.MENU_CARS }}</span>
                </router-link>
            </li>
            <li class="asw-navi-list__item">
                <router-link
                    to="/areas"
                    class="asw-navi-list__link"
                    :class="{ 'asw-navi-list__link--active': $route.path == '/areas' }"
                >
                    <img
                        :src="$route.path == '/areas' ? iconAreasActive : iconAreas"
                        class="asw-navi-list__link-img"
                        alt=""
                    />
                    <span class="asw-navi-list__link-text">{{ getTranslate.MENU_AREAS }}</span>
                </router-link>
            </li>
            <li class="asw-navi-list__item">
                <router-link
                    to="/firmwares"
                    class="asw-navi-list__link"
                    :class="{ 'asw-navi-list__link--active': $route.path == '/firmwares' }"
                    v-if="checkArrayIncludes(profile.attr?.array, ['SUPER_ADMIN'])"
                >
                    <img
                        :src="$route.path == '/firmwares' ? iconFirmwareActive : iconFirmware"
                        class="asw-navi-list__link-img"
                        alt=""
                    />
                    <span class="asw-navi-list__link-text">{{ getTranslate.MENU_FIRMWARES }}</span>
                </router-link>
            </li>
            <li class="asw-navi-list__item">
                <router-link
                    to="/users"
                    class="asw-navi-list__link"
                    :class="{ 'asw-navi-list__link--active': $route.path == '/users' }"
                    v-if="checkArrayIncludes(profile.attr?.array, ['GROUP_ADMIN', 'SUPER_ADMIN'])"
                >
                    <img
                        :src="$route.path == '/users' ? iconUsersActive : iconUsers"
                        class="asw-navi-list__link-img"
                        alt=""
                    />
                    <span class="asw-navi-list__link-text">{{ getTranslate.MENU_USERS }}</span>
                </router-link>
            </li>
            <li class="asw-navi-list__item">
                <router-link
                    to="/guide"
                    class="asw-navi-list__link"
                    :class="{ 'asw-navi-list__link--active': $route.path == '/guide' }"
                >
                    <img
                        :src="$route.path == '/guide' ? iconGuideActive : iconGuide"
                        class="asw-navi-list__link-img"
                        alt=""
                    />
                    <span class="asw-navi-list__link-text">{{ getTranslate.MENU_GUIDE }}</span>
                </router-link>
            </li>
            <li class="asw-navi-list__item d-block d-xl-none">
                <a href="#" class="asw-navi-list__link" @click.prevent="requestsStore.logout">
                    <span class="material-icons asw-navi-list__link-img"> logout </span>
                    <span class="asw-navi-list__link-text">{{ getTranslate.LOGOUT }}</span>
                </a>
            </li>
        </ul>
    </nav>
</template>

<style lang="scss">
@use '@/assets/styles/scss/components/navi.scss';
</style>
